// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;From the rising of the sun to its setting&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let the name of the Lord be praised.<br> </p> </div></div>";
// Exports
module.exports = code;